"use client";

import { useLanguage } from "@/context/language-context";

export function ProfileCard() {
  const { content } = useLanguage();

  return (
    <div className="relative w-full max-w-[340px]">
      <div
        aria-hidden
        className="absolute inset-0 translate-x-2 translate-y-3 rounded-2xl bg-foreground/[0.04]"
      />
      <figure className="relative -rotate-1 overflow-hidden rounded-2xl border border-border/60 bg-card shadow-[0_2px_8px_rgba(0,0,0,0.06),0_16px_40px_rgba(0,0,0,0.1)]">
        <img
          src="/images/mikkel.webp"
          alt="Mikkel Scheike"
          className="aspect-[4/5] w-full object-cover object-center"
        />
        <figcaption className="absolute inset-x-0 bottom-0 bg-linear-to-t from-background via-background/90 to-transparent px-5 pt-24 pb-5">
          <p className="text-base font-bold tracking-tight text-balance text-foreground">
            {content.about.profile_name}
          </p>
          <p className="mt-1.5 text-xs leading-snug text-balance text-muted-foreground">
            {content.about.profile_role}
          </p>
        </figcaption>
      </figure>
    </div>
  );
}

/** @deprecated Renamed to ProfileCard */
export const HangingProfile = ProfileCard;
